import MODULE_NAME from './app.js';

/**
 * @ngdoc object
 * @name festzelt-os
 * @description
 *
 */
angular.module(MODULE_NAME)
    .config([
        '$uibModalProvider',
        config
    ]);

function config($uibModalProvider) {
    $uibModalProvider.backdrop = 'static';
}



// WEBPACK FOOTER //
// ./src/app/app-module-config.js